"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[588],{

/***/ 96588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ COMPONENT_CONFIG; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/image/index.tsx
var components_image = __webpack_require__(79743);
// EXTERNAL MODULE: ./src/constants/styles.ts
var styles = __webpack_require__(30438);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(86879);
// EXTERNAL MODULE: ./src/constants/envConfig.ts + 1 modules
var envConfig = __webpack_require__(73690);
;// CONCATENATED MODULE: ./src/utils/s3.ts

var S3_BUCKET = "https://koala-web-ordering-themes.s3.amazonaws.com";
function getS3Path(slug, assetPath) {
    return "".concat(S3_BUCKET, "/").concat(slug, "/").concat(envConfig/* ENV */.Vi, "/").concat(assetPath);
}

;// CONCATENATED MODULE: ./src/brand-components/capital-tacos/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        "px 0 0 0;\n  padding: ",
        "px;\n  text-align: center;\n\n  img {\n    margin: 0 auto;\n    max-height: 150px;\n  }\n\n  h1 {\n    font-size: 24px;\n    color: #ef4b24;\n    line-height: 110%;\n    font-family: ",
        ";\n  }\n\n  p {\n    font-family: ",
        ";\n    font-size: 17px;\n    color: #ef4b24;\n  }\n\n  ul {\n    color: #ef4b24;\n    font-family: ",
        ";\n    font-size: 17px;\n    padding-left: 20px;\n    text-align: left;\n  }\n\n  a {\n    text-decoration: underline;\n    color: #ef4b24;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function CapitalTacosRewardsTerms() {
    var slug = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.organization.organization;
    }).slug;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModalContent, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                alt: "Capital Rewards",
                height: 150,
                src: getS3Path(slug, "images/capital-rewards.png"),
                width: 133
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "New Year, New Rewards. Always Done Right."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Now in 2023, we have new and exciting updates to Capital Rewards: More opportunities to redeem your points, and we will be dropping new exclusive rewards offers every month."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "1. Sign Up & Score Immediately: Join Capital Rewards and receive Free Small Queso Bites with your first $10+ order!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "2. Order: Receive 1 rewards point with every dollar spent"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "3. Unlock Rewards & More Now Ways to Redeem Points For Free Items - On Us:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Small craft soda (35 points)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Free small salsa (55 points)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Small queso (75 Points)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Small mini churros (100 Points)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Mexican street corn (125 Points)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Fries with Queso (150 Points)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Big kahuna taco (175 Points)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Chicken bacon ranchadilla (200 Points)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Epic Nachos (250 Points)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "4. Stay In The Capital Know: Stay on top of your email for exclusive #TacoTuesday deals, new and secret menu items, and a whole lot more..."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Exclusive rewards offers every dropping every month"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Learn More About Capital Rewards",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.capitaltacos.com/rewardsinfo",
                        target: "_blank",
                        rel: "noreferrer",
                        children: "here"
                    })
                ]
            })
        ]
    });
}
var StyledModalContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6aedc383-0"
})(_templateObject(), styles/* LAYOUT.GUTTER */._.GUTTER, styles/* LAYOUT.GUTTER */._.GUTTER, function(param) {
    var theme = param.theme;
    return theme.secondary_font.regular.font_family;
}, function(param) {
    var theme = param.theme;
    return theme.secondary_font.regular.font_family;
}, function(param) {
    var theme = param.theme;
    return theme.secondary_font.regular.font_family;
});

// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/uielements/genericModal/index.tsx
var genericModal = __webpack_require__(85526);
// EXTERNAL MODULE: ./src/components/uielements/primaryButton/styles.tsx
var primaryButton_styles = __webpack_require__(25167);
// EXTERNAL MODULE: ./src/constants/routes.ts
var routes = __webpack_require__(25643);
;// CONCATENATED MODULE: ./src/brand-components/deepweb/floating-button.tsx

function floating_button_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  bottom: 20px;\n  display: flex;\n  height: 60px;\n  justify-content: center;\n  line-height: 60px;\n  padding: 0 30px;\n  position: fixed;\n  right: 20px;\n  transition: all 0.2s linear;\n  z-index: ",
        ";\n\n  span {\n    padding-left: 12px;\n  }\n\n  @media (max-width: 1024px) {\n    padding: 0;\n    width: 60px;\n\n    span {\n      display: none;\n    }\n  }\n\n  @media (max-width: 767px) {\n    display: ",
        ";\n  }\n"
    ]);
    floating_button_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 420px;\n  width: 100%;\n  padding-top: 20px;\n  overflow: hidden;\n  overflow-y: scroll;\n\n  @media (max-width: 767px) {\n    height: 100vh;\n    overflow-x: auto;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  min-width: 420px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











function DeepFloatingButton() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), showRules = ref[0], setShowRules = ref[1];
    var toast = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.global;
    }).toast;
    var slug = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.organization.organization;
    }).slug;
    // Hide the button if we're not on the store, checkout, or order confirmation pages.
    if (router.pathname !== routes/* ROUTES.STORE */.Z6.STORE && router.pathname !== routes/* ROUTES.CHECKOUT */.Z6.CHECKOUT && router.pathname !== routes/* ROUTES.ORDER_CONFIRMATION */.Z6.ORDER_CONFIRMATION) {
        return null;
    }
    // Hide this component if a toast is visible since they will clash.
    if (toast.display) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(genericModal/* default */.Z, {
                header: "Reward Rules",
                modalOpen: showRules,
                toggleModal: setShowRules,
                maxWidth: 740,
                name: "Deep Rewards Rules Modal",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRewardsContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRewardsImage, {
                        src: "https://loyalty.deepindiankitchen.com/Deep%20-%20Loyalty%20Program%20Rules.png"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLink, {
                onClick: function() {
                    return setShowRules(true);
                },
                hideOnMobile: router.pathname === routes/* ROUTES.CHECKOUT */.Z6.CHECKOUT,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                        width: 24,
                        height: 24,
                        alt: "Reward Rules",
                        src: getS3Path(slug, "images/icons/icon-rewards.svg")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Reward Rules"
                    })
                ]
            })
        ]
    });
}
var StyledLink = (0,styled_components_browser_esm/* default */.ZP)(primaryButton_styles/* StyledPrimaryButton */.D).withConfig({
    componentId: "sc-eecb30ff-0"
})(floating_button_templateObject(), styles/* ORDER.CART */.kl.CART - 1, function(param) {
    var hideOnMobile = param.hideOnMobile;
    return hideOnMobile ? "none" : "flex";
});
var StyledRewardsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eecb30ff-1"
})(_templateObject1());
var StyledRewardsImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-eecb30ff-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/brand-components/deepweb/index.ts


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ./src/redux/cmsConfig/utils.ts
var utils = __webpack_require__(73393);
;// CONCATENATED MODULE: ./src/brand-components/graeters/index.tsx


function graeters_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 24px;\n"
    ]);
    graeters_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function graeters_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 18px;\n"
    ]);
    graeters_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function graeters_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: underline;\n"
    ]);
    graeters_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






function GraetersRewardsTerms() {
    var slug = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.organization.organization;
    }).slug;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalContent, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                alt: "Graeter's Rewards",
                height: 196,
                src: getS3Path(slug, "images/how-rewards-work.png"),
                width: 294
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                children: "Order Ice Cream"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                children: "Order pints and other to-go items ahead for pick-up or get them delivered to you."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                children: "Earn Sweet Rewards"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                children: "Track and earn points for every purchase from our retail stores, every 100 points you'll get a $5 reward."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                children: "Get Offers & News"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                children: "Get the latest scoop on offers, promotions and all things Graeter's."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph, {
                children: [
                    "For more information, please visit our\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                        href: "https://www.graeters.com/help-sweet-rewards",
                        target: "_blank",
                        rel: "noreferrer",
                        "aria-label": "Go to Rewards page",
                        children: "FAQ page"
                    }),
                    "."
                ]
            })
        ]
    });
}
var ModalContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9d238a95-0"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        margin: "20px 0 0",
        padding: "20px"
    }, (0,utils/* getFontStyles */.l)(theme.text.primary_font, [
        "color"
    ]));
});
var Header = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-9d238a95-1"
})(graeters_templateObject(), function(param) {
    var theme = param.theme;
    return theme.primary_font.bold.font_family;
});
var Paragraph = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-9d238a95-2"
})(graeters_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.primary_font.regular.font_family;
});
var Link = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-9d238a95-3"
})(graeters_templateObject2());

;// CONCATENATED MODULE: ./src/brand-components/luna-grill/index.tsx







function LunaGrillRewardsTerms() {
    var slug = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.organization.organization;
    }).slug;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(luna_grill_StyledModalContent, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                alt: "Inspiring Good Food Choices",
                height: 147,
                src: getS3Path(slug, "images/luna-rewards.png"),
                width: 294
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "EAT REAL. GET REWARDED."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                children: "Enjoy the fresh flavors of real Mediterranean cooking with Luna Grill Mediterranean Kitchen. Earn rewards on dine-in, pickup, curbside and delivery orders placed through our app or website today!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Earn 1 point for every $1 you spend."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Earn 100 points, and get $5 off your next visit!"
                    })
                ]
            })
        ]
    });
}
var luna_grill_StyledModalContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c2f9735c-0"
})(function(param) {
    var theme = param.theme;
    return {
        /** @FIXME font refactor. (hard coded font family) */ fontFamily: '"springsteel-bold", "Helvetica" !important',
        padding: "20px",
        h1: {
            color: theme.global.primary_active_color
        },
        "h4, li": (0,_object_spread/* default */.Z)({
            fontSize: "20px"
        }, (0,utils/* getFontStyles */.l)(theme.text.primary_font, [
            "color"
        ])),
        li: {
            fontSize: "18px"
        },
        ul: {
            textAlign: "left"
        }
    };
});

;// CONCATENATED MODULE: ./src/brand-components/mooyah/index.tsx


function mooyah_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 24px;\n"
    ]);
    mooyah_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function mooyah_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 18px;\n"
    ]);
    mooyah_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function mooyah_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: underline;\n"
    ]);
    mooyah_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






function MooyahRewardsTerms() {
    var slug = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.organization.organization;
    }).slug;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(mooyah_ModalContent, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                alt: "Mooyah rewards",
                height: 276,
                src: getS3Path(slug, "images/MOOYAH-rewards.jpg"),
                width: 294
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mooyah_Header, {
                children: "Delicious rewards in every bite!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mooyah_Paragraph, {
                children: "Score free personal fries with any purchase just for signing up."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mooyah_Paragraph, {
                children: "Earn points for all your food & drink orders ($1 = 1 point)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mooyah_Paragraph, {
                children: "Unlock your favorite menu items with your points up to a free burger."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mooyah_Paragraph, {
                children: "Awesome offers & bonus points dropped all year long."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mooyah_Paragraph, {
                children: "Be the first to know the latest news & local deals."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(mooyah_Paragraph, {
                children: [
                    "For more details visit our\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mooyah_Link, {
                        href: "https://mooyah.com/rewards/",
                        target: "_blank",
                        rel: "noreferrer",
                        "aria-label": "Go to Rewards page",
                        children: "rewards page"
                    }),
                    "."
                ]
            })
        ]
    });
}
var mooyah_ModalContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2304e9a4-0"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        margin: "20px 0 0",
        padding: "20px"
    }, (0,utils/* getFontStyles */.l)(theme.text.primary_font, [
        "color"
    ]));
});
var mooyah_Header = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-2304e9a4-1"
})(mooyah_templateObject(), function(param) {
    var theme = param.theme;
    return theme.primary_font.bold.font_family;
});
var mooyah_Paragraph = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-2304e9a4-2"
})(mooyah_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.primary_font.regular.font_family;
});
var mooyah_Link = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-2304e9a4-3"
})(mooyah_templateObject2());

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
;// CONCATENATED MODULE: ./src/brand-components/pancheros/index.tsx





function PancherosRewardsTerms() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(pancheros_StyledModalContent, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "Pancheros Rewards"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Are you hungry? You will be!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: "1. Order:"
                            }),
                            " Build your burrito and order for pick-up or delivery."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: "2. Earn:"
                            }),
                            " Get 1 point for every dollar you spend."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: "3. Eat:"
                            }),
                            " After earning 100 points, get a Free Entree of your choice."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Yes, it's that easy."
            })
        ]
    });
}
var pancheros_StyledModalContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-233ec9bb-0"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        fontFamily: theme.primary_font.regular.font_family,
        margin: 0,
        padding: "20px",
        textAlign: "center"
    }, (0,utils/* getFontStyles */.l)(theme.text.primary_font, [
        "color"
    ])), {
        h1: {
            color: theme.global.primary_active_color,
            fontSize: "28px",
            fontFamily: theme.secondary_font.medium.font_family,
            fontWeight: 800,
            margin: 0,
            "@media (max-width: 767px)": {
                fontSize: "24px"
            }
        },
        h2: {
            fontSize: "20px",
            margin: "0 0 30px",
            fontWeight: 100
        },
        "p,ul": {
            fontSize: "16px",
            margin: "20px 0"
        },
        ul: {
            listStyleType: "none",
            padding: 0
        },
        "@media (max-width: 767px)": {
            fontSize: "14px"
        }
    });
});

;// CONCATENATED MODULE: ./src/brand-components/pfchangs/index.tsx


function pfchangs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: underline;\n"
    ]);
    pfchangs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function pfchangs_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--size-7);\n  background-color: black;\n  font-family: ",
        ";\n  padding: ",
        "px;\n  text-align: center;\n"
    ]);
    pfchangs_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







function PfChangsRewardsTerms() {
    var slug = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.organization.organization;
    }).slug;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(pfchangs_StyledModalContent, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                        alt: "P.F. Changs Rewards Platinum",
                        height: 98,
                        src: getS3Path(slug, "images/PFCRewards-Platinum.png"),
                        width: 300
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                        alt: "",
                        role: "presentation",
                        height: 60,
                        src: getS3Path(slug, "images/icons/EnjoyMoreIcon.png"),
                        width: 49
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(pfchangs_Header, {
                        children: "EARN MORE"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(pfchangs_Paragraph, {
                        children: "20 points with every $1 spent"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(pfchangs_Paragraph, {
                        children: "(2x more than Gold Rewards Members)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                        alt: "",
                        role: "presentation",
                        height: 60,
                        src: getS3Path(slug, "images/icons/EarnMoreIcon.png"),
                        width: 32
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(pfchangs_Header, {
                        children: "ENJOY MORE"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(pfchangs_Paragraph, {
                        children: "Free delivery with every order"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(pfchangs_Paragraph, {
                        children: "$15 Reward with every 2,000 points earned"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                        alt: "",
                        role: "presentation",
                        height: 60,
                        src: getS3Path(slug, "images/icons/VIPIcon.png"),
                        width: 62
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(pfchangs_Header, {
                        children: "AS A VIP"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(pfchangs_Paragraph, {
                        children: "Birthday Rewards, priority reservations, VIP concierge access & more - exclusively for Platinum Members"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                        alt: "",
                        role: "presentation",
                        height: 41,
                        src: getS3Path(slug, "images/Platinum-DecorativeLine.png"),
                        width: 200
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(pfchangs_Paragraph, {
                        children: [
                            "Visit our\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(pfchangs_Link, {
                                as: "a",
                                href: "https://www.pfchangs.com/REWARDS",
                                target: "_blank",
                                rel: "noreferrer",
                                "aria-label": "Go to Rewards page",
                                children: "Rewards page"
                            }),
                            "\xa0to learn more & join."
                        ]
                    })
                ]
            })
        ]
    });
}
var pfchangs_Paragraph = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-1a082e82-0"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        fontSize: "18px",
        margin: 0,
        fontFamily: theme.primary_font.regular.font_family
    }, (0,utils/* getFontStyles */.l)(theme.text.primary_font, [
        "color"
    ]));
});
var pfchangs_Link = (0,styled_components_browser_esm/* default */.ZP)(pfchangs_Paragraph).withConfig({
    componentId: "sc-1a082e82-1"
})(pfchangs_templateObject());
var pfchangs_Header = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-1a082e82-2"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        fontFamily: theme.secondary_font.bold.font_family,
        fontSize: "18px",
        marginTop: 0
    }, (0,utils/* getFontStyles */.l)(theme.text.secondary_font, [
        "color"
    ]));
});
var pfchangs_StyledModalContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a082e82-3"
})(pfchangs_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.primary_font.regular.font_family;
}, styles/* LAYOUT.GUTTER */._.GUTTER);

;// CONCATENATED MODULE: ./src/brand-components/pokeworks/index.tsx







function PokeworksRewardsTerms() {
    var slug = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.organization.organization;
    }).slug;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(pokeworks_StyledModalContent, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                alt: "Pokeworks Loyalty Program",
                height: 200,
                src: getS3Path(slug, "images/PW_LoyaltyModalIcon_400x400_3.png"),
                width: 200
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "Earn $9 when you spend $99!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Use your Pokeworks Rewards account to earn points with every purchase. Just order online, in-app, scan your QR code at the register or manually enter your receipt."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Save time and order ahead or get your poke delivered for only $1.99!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "Redeem rewards"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Select from the available rewards on your account and order online, in-app or scan your QR code at the cash register to apply it to your order."
            })
        ]
    });
}
var pokeworks_StyledModalContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7f4e001a-0"
})(function(param) {
    var theme = param.theme;
    return {
        fontFamily: theme.primary_font.regular.font_family,
        padding: "20px",
        textAlign: "center",
        img: {
            maxHeight: "200px",
            maxWidth: "200px"
        },
        h1: (0,_object_spread/* default */.Z)({
            fontFamily: theme.primary_font.bold.font_family,
            fontSize: "24px"
        }, (0,utils/* getFontStyles */.l)(theme.text.primary_font, [
            "color"
        ])),
        p: {
            color: "#84756e",
            fontSize: "18px"
        }
    };
});

;// CONCATENATED MODULE: ./src/brand-components/pollo-campero/index.tsx








function PolloCamperoRewardsTerms() {
    var slug = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.organization.organization;
    }).slug;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(pollo_campero_StyledModalContent, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                alt: "Earn 10 points for every $1 spent. Bronze - Get $10 for every 1000 points. Silver - Get $12 for every 1000 points. Gold - Get $14 for every 1000 points.",
                height: 230,
                src: getS3Path(slug, "images/pollo_campero_how_rewards_work.png"),
                width: 294
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "Join our Loyalty Club!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "As a member of this extremely tasty club you earn points with every purchase (online and in-store!) in addition to exclusive member-only offers, birthday gift, and referral awards! Download the Campero app and join today!"
            })
        ]
    });
}
var pollo_campero_StyledModalContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bba36377-0"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        margin: "20px 0 0",
        padding: "20px"
    }, (0,utils/* getFontStyles */.l)(theme.text.primary_font, [
        "color"
    ])), {
        img: {
            width: "100%"
        },
        h1: {
            fontFamily: theme.primary_font.bold.font_family,
            fontSize: "24px"
        },
        p: {
            fontFamily: theme.primary_font.regular.font_family,
            fontSize: "18px"
        }
    });
});

;// CONCATENATED MODULE: ./src/brand-components/salsaritas/index.tsx








function SalsaritasRewardsTerms() {
    var slug = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.organization.organization;
    }).slug;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(salsaritas_StyledModalContent, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "Eat Salsarita’s, Earn Rewards!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                alt: "Salsarita's Rewards",
                height: 120,
                src: getS3Path(slug, "images/salsaritas-rewards.png"),
                width: 405
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Your loyalty is rewarded in different ways! Receive in-app offers and rewards as you dine at or cater with Salsarita’s. Offers include $5 Off signup & birthday rewards, extra points, & more!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "For more details visit our",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://salsaritas.com/rewards/",
                        target: "_blank",
                        rel: "noreferrer",
                        children: "rewards page."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                    children: "*Valid on dine-in, take-out, and online purchases."
                })
            })
        ]
    });
}
var salsaritas_StyledModalContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-603c64e1-0"
})(function(param) {
    var theme = param.theme;
    return {
        padding: "20px",
        textAlign: "center",
        img: {
            margin: "0 auto",
            maxHeight: "150px"
        },
        h1: (0,_object_spread/* default */.Z)({
            lineHeight: "110%",
            fontFamily: theme.secondary_font.regular.font_family,
            margin: "0 0 30px"
        }, (0,utils/* getFontStyles */.l)(theme.text.secondary_font, [
            "font_size"
        ])),
        p: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            fontFamily: theme.primary_font.regular.font_family
        }, (0,utils/* getFontStyles */.l)(theme.text.secondary_font, [
            "font_size"
        ])), {
            small: {
                fontSize: "0.75em"
            }
        }),
        a: {
            textDecoration: "underline",
            color: theme.buttons.primary_button_background_color
        }
    };
});

;// CONCATENATED MODULE: ./src/brand-components/scratch-kitchen/index.tsx







function ScratchKitchenRewardsTerms() {
    var slug = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.organization.organization;
    }).slug;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(scratch_kitchen_StyledModalContent, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                alt: "Treat Yo Self",
                height: 189,
                src: getS3Path(slug, "images/Treat_Yo_Self-01.svg"),
                width: 200
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "1: Earn Points with Every Purchase"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Every time you place an order through ScratchKitchen.com you will earn points that can be cashed in for rewards."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "2: Use Points to Redeem Rewards"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Your available rewards are visible on your account page and will appear at checkout so that you can easily select and apply them to your order."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "For more details visit our\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.scratchkitchen.com/rewards/",
                        target: "_blank",
                        rel: "noreferrer",
                        "aria-label": "Go to Rewards page",
                        children: "rewards page"
                    }),
                    "."
                ]
            })
        ]
    });
}
var scratch_kitchen_StyledModalContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1e6d7601-0"
})(function(param) {
    var theme = param.theme;
    return {
        fontFamily: theme.primary_font.regular.font_family,
        padding: "20px",
        textAlign: "center",
        img: {
            maxHeight: "200px",
            maxWidth: "200px"
        },
        h1: (0,_object_spread/* default */.Z)({
            fontFamily: theme.primary_font.bold.font_family,
            fontSize: "24px"
        }, (0,utils/* getFontStyles */.l)(theme.text.primary_font, [
            "color"
        ])),
        "p,a": {
            color: "#84756e",
            fontSize: "18px"
        },
        a: {
            textDecoration: "underline"
        }
    };
});

;// CONCATENATED MODULE: ./src/brand-components/vg/index.tsx

function vg_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding: 30px 35px 0px;\n  margin-top: 10px;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  box-shadow: 0 2px 0 0 ",
        ";\n  text-align: left;\n  font-family: ",
        ";\n\n  h1 {\n    font-size: 16px;\n    margin-top: 24px;\n  }\n\n  p {\n    font-family: ",
        ";\n    margin-bottom: 25px;\n    font-size: 12px;\n    padding-right: 30px;\n    line-height: 20px;\n  }\n\n  > div {\n    display: flex;\n  }\n  .appIcons {\n    img {\n      height: 40px;\n      padding-right: 5px;\n      margin-bottom: 20px;\n      @media (max-width: 577px) {\n        height: 38px;\n      }\n    }\n  }\n  .rightContent {\n    margin-left: auto;\n    span {\n      vertical-align: bottom;\n    }\n    @media (max-width: 577px) {\n      display: none;\n    }\n  }\n"
    ]);
    vg_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function VgOrderConfirmationFooter() {
    var slug = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.organization.organization;
    }).slug;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOrderDetailReward, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            children: "Sign Up for Veggie Grill Rewards!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "You'll earn $9 for every $99 spent. Download the Veggie Grill app to view your progress."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "appIcons",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://itunes.apple.com/us/app/vg-rewards/id1329899808?ls=1&mt=8",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                                        alt: "Download on the App Store",
                                        height: 40,
                                        src: getS3Path(slug, "images/Download_on_the_App_Store_Badge_US-UK_135x40.svg"),
                                        width: 140
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://play.google.com/store/apps/details?id=com.ak.app.veggiegrill.activity",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                                        alt: "Get it on Google Play",
                                        height: 40,
                                        src: getS3Path(slug, "images/google-play-badge.png"),
                                        width: 140
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "rightContent",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                        alt: "",
                        role: "presentation",
                        height: 190,
                        src: getS3Path(slug, "images/VG_Reward.png"),
                        width: 176
                    })
                })
            ]
        })
    });
}
var StyledOrderDetailReward = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b426c515-0"
})(vg_templateObject(), styles/* COLORS.WHITE */.DM.WHITE, styles/* COLORS.MEDIUMGRAY */.DM.MEDIUMGRAY, styles/* COLORS.MEDIUMGRAY */.DM.MEDIUMGRAY, function(param) {
    var theme = param.theme;
    return theme.primary_font.medium.font_family;
}, function(param) {
    var theme = param.theme;
    return theme.primary_font.light.font_family;
});

;// CONCATENATED MODULE: ./src/brand-components/index.ts












var COMPONENT_CONFIG = {
    MODAL_HOW_REWARDS_WORK: {
        capitaltacos: CapitalTacosRewardsTerms,
        graeters: GraetersRewardsTerms,
        lunagrill: LunaGrillRewardsTerms,
        mooyah: MooyahRewardsTerms,
        pancheros: PancherosRewardsTerms,
        pfchangs: PfChangsRewardsTerms,
        pokeworks: PokeworksRewardsTerms,
        pollocampero: PolloCamperoRewardsTerms,
        salsaritas: SalsaritasRewardsTerms,
        salsaritascatering: SalsaritasRewardsTerms,
        scratchkitchen: ScratchKitchenRewardsTerms
    },
    GLOBAL_FLOATING: {
        deepweb: DeepFloatingButton
    },
    ORDER_CONFIRMATION_FOOTER: {
        "vg-catering": VgOrderConfirmationFooter
    }
};


/***/ }),

/***/ 11995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64297);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58408);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _utils_errorReporter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19663);





var GenericErrorBoundary = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(GenericErrorBoundary, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(GenericErrorBoundary);
    function GenericErrorBoundary() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, GenericErrorBoundary);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    var _proto = GenericErrorBoundary.prototype;
    _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
        console.log(error, "ERROR");
        console.log(errorInfo, "ERROR INFO");
        // Fire error event
        _utils_errorReporter__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(error, "error");
    };
    _proto.render = function render() {
        if (this.state.hasError) {
            return null;
        }
        return this.props.children;
    };
    GenericErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError() {
        return {
            hasError: true
        };
    };
    return GenericErrorBoundary;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
/* harmony default export */ __webpack_exports__["Z"] = (GenericErrorBoundary);


/***/ }),

/***/ 79743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19126);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70595);





/**
 * Custom loader for next/image to optimize and
 * cache images using Koala's Image Resizer API.
 */ function loader(param) {
    var width = param.width, src = param.src, _quality = param.quality, quality = _quality === void 0 ? 85 : _quality;
    // Don't try to resize vector graphics like SVGs & PDFs
    if (src.endsWith(".svg") || src.endsWith(".pdf")) {
        return src;
    }
    // Otherwise, pass the image to the resizer.
    return "".concat(_utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .IMAGE_RESIZER */ .nq, "?source=").concat(src, "&").concat((0,qs__WEBPACK_IMPORTED_MODULE_3__.stringify)({
        format: "auto",
        quality: quality,
        width: width
    }));
}
/**
 * Wraps Next's image component to use the Koala Image Resizer.
 * @see https://nextjs.org/docs/api-reference/next/legacy/image
 */ function Image(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        unoptimized: true,
        loader: loader
    }, props));
}


/***/ }),

/***/ 66086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ji": function() { return /* binding */ XSvg; },
/* harmony export */   "W": function() { return /* binding */ FilledXSvg; },
/* harmony export */   "e9": function() { return /* binding */ ConnectedXButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89961);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30438);
/* harmony import */ var _redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73393);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 1;\n  background: none;\n  border: none;\n  padding: ",
        "px;\n\n  img {\n    display: block;\n    height: 24px;\n    width: 24px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var _XButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function Button(param) {
    var id = param.id, onClick = param.onClick, name = param.name, theme = param.theme, className = param.className;
    var color = (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFontStyles */ .l)(theme.modals.font).color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledXButton, {
        className: className,
        onClick: onClick,
        "aria-label": "Close ".concat(name),
        id: id,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(XSvg, {
            color: color
        })
    });
});
var ConnectedXButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .withTheme */ .Zz)(_XButton);
var _XSvg = function(param) {
    var color = param.color, _size = param.size, size = _size === void 0 ? 15 : _size, theme = param.theme;
    var ref = (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFontStyles */ .l)(theme.modals.font), fallbackColor = ref.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 15 15",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                    d: "M-10-10h34v34h-34z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("g", {
                    stroke: color !== null && color !== void 0 ? color : fallbackColor,
                    strokeWidth: "1.9",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M13.304.381L.38 13.304M.38.381l12.924 12.923"
                    })
                })
            ]
        })
    });
};
var XSvg = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .withTheme */ .Zz)(_XSvg);
var StyledXButton = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-d75ea631-0"
})(_templateObject(), _constants_styles__WEBPACK_IMPORTED_MODULE_3__/* .LAYOUT.GUTTER */ ._.GUTTER);
var _FilledXSvg = function(param) {
    var color = param.color, _size = param.size, size = _size === void 0 ? 20 : _size, theme = param.theme;
    var ref = (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFontStyles */ .l)(theme.modals.font), fallbackColor = ref.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
            d: "M9.99121 18.7422C14.9746 18.7422 19.0879 14.6289 19.0879 9.6543C19.0879 4.67969 14.9658 0.566406 9.98242 0.566406C5.00781 0.566406 0.90332 4.67969 0.90332 9.6543C0.90332 14.6289 5.0166 18.7422 9.99121 18.7422ZM6.99414 13.4863C6.52832 13.4863 6.15918 13.1172 6.15918 12.6426C6.15918 12.4316 6.24707 12.2207 6.41406 12.0625L8.80469 9.66309L6.41406 7.27246C6.24707 7.11426 6.15918 6.90332 6.15918 6.69238C6.15918 6.21777 6.52832 5.85742 6.99414 5.85742C7.24023 5.85742 7.43359 5.93652 7.5918 6.09473L9.99121 8.48535L12.3994 6.08594C12.5752 5.91895 12.7598 5.83984 12.9971 5.83984C13.4629 5.83984 13.832 6.20898 13.832 6.6748C13.832 6.89453 13.7441 7.08789 13.5771 7.26367L11.1865 9.66309L13.5771 12.0537C13.7354 12.2207 13.8232 12.4229 13.8232 12.6426C13.8232 13.1172 13.4541 13.4863 12.9795 13.4863C12.7422 13.4863 12.54 13.3984 12.373 13.2402L9.99121 10.8584L7.60938 13.2402C7.45117 13.4072 7.24023 13.4863 6.99414 13.4863Z",
            fill: color !== null && color !== void 0 ? color : fallbackColor
        })
    });
};
var FilledXSvg = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .withTheme */ .Zz)(_FilledXSvg);


/***/ }),

/***/ 64390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ LinkHoverCss; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89961);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-decoration: underline;\n  transition: opacity 0.2s linear;\n\n  &:hover {\n    opacity: 0.7;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var LinkHoverCss = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject());


/***/ }),

/***/ 38806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ GenericFocusTrap; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var focus_trap_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79553);
/* harmony import */ var focus_trap_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(focus_trap_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _components_genericErrorBoundary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11995);







/**
 * Issue: https://github.com/focus-trap/focus-trap-react/issues/20
 * See PR for more details: https://github.com/fuzz-productions/koala-ordering-webapp/pull/805
 *
 * Usage rules:
 *
 * 1. Do not nest a focus trap in a parent with visibility: hidden and also give the children
 *    visibility: hidden when basing this CSS property value off of a prop. Focus traps
 *    must be parents of elements with varying visibility.
 * 2. Do not use the same prop for every visibility: hidden || visible. If you need more than
 *    one nested visibility rule, the HTML structure is most likely worth re-thinking.
 * 3. Every active focus trap MUST have a tabbable element. There is no exception to this rule.
 *    If it does not have a focusable element, it is not semantic HTML and the application will break.
 */ var GenericFocusTrap = function(props) {
    var active = props.active, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, [
        "active"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), activateTrap = ref[0], setActivateTrap = ref[1];
    var childrenContainer = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!active) {
            setActivateTrap(false);
            return;
        }
        if (!childrenContainer.current || active === activateTrap) {
            return;
        }
        var tabbableElement = childrenContainer.current.querySelector('button, a[href], input, select, textarea, audio[controls], video[controls], [contenteditable], form:not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])');
        if (!tabbableElement) {
            return;
        }
        var activateWhenReady = function() {
            if (active) {
                setActivateTrap(true);
            }
        };
        // Enable the trap on the next frame once the modal content is rendered.
        // Fall back to IntersectionObserver only when the tabbable element is not
        // visible yet, which preserves the historical workaround for hidden nodes.
        var frameId = requestAnimationFrame(function() {
            var offsetParent = tabbableElement.offsetParent;
            if (offsetParent !== null || tabbableElement.getClientRects().length > 0) {
                activateWhenReady();
            }
        });
        if (!(window === null || window === void 0 ? void 0 : window.IntersectionObserver)) {
            return function() {
                cancelAnimationFrame(frameId);
            };
        }
        var observer = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting && active) {
                    activateWhenReady();
                    observer.unobserve(tabbableElement);
                }
            });
        });
        observer.observe(tabbableElement);
        return function() {
            cancelAnimationFrame(frameId);
            observer.disconnect();
        };
    }, [
        active,
        activateTrap
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_genericErrorBoundary__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            ref: childrenContainer,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((focus_trap_react__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                active: activateTrap
            }, otherProps), {
                children: props.children
            }))
        })
    });
};


/***/ }),

/***/ 85526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GenericModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64297);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58408);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61969);
/* harmony import */ var _analytics_events__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45003);
/* harmony import */ var _components_uielements_X__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66086);
/* harmony import */ var _components_uielements_genericFocusTrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38806);









var GenericModal = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(GenericModal, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(GenericModal);
    function GenericModal() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(this, GenericModal);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            height: null
        };
        _this.handleResize = function() {
            _this.setState({
                height: window.innerHeight
            });
        };
        _this.close = function(evt) {
            var _props = _this.props, toggleModal = _props.toggleModal, disableModalClose = _props.disableModalClose, onClose = _props.onClose;
            // Close modal on 'esc' press
            if (evt.keyCode === 27 && toggleModal && !disableModalClose) {
                toggleModal(false);
                onClose && onClose();
            }
        };
        return _this;
    }
    var _proto = GenericModal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.setState({
            height: window.innerHeight
        });
        document.addEventListener("keydown", this.close);
        window.addEventListener("resize", this.handleResize);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        document.removeEventListener("keydown", this.close);
        window.removeEventListener("resize", this.handleResize);
    };
    _proto.componentDidUpdate = function componentDidUpdate(param) {
        var modalOpen = param.modalOpen, name = param.name;
        // Fire KA event if modal is open
        if (this.props.modalOpen !== modalOpen && this.props.modalOpen) {
            // Consolidated pageview events
            (0,_analytics_events__WEBPACK_IMPORTED_MODULE_3__/* .pageViewEventHandler */ .f)(name);
        }
    };
    _proto.render = function render() {
        var _props = this.props, children = _props.children, modalOpen = _props.modalOpen, header = _props.header, ariaLabel = _props.ariaLabel, maxWidth = _props.maxWidth, name = _props.name, toggleModal = _props.toggleModal, disableModalClose = _props.disableModalClose, ariaLabelledBy = _props["aria-labelledby"], _enableFocusTrap = _props.enableFocusTrap, enableFocusTrap = _enableFocusTrap === void 0 ? false : _enableFocusTrap;
        var height = this.state.height;
        if (!modalOpen) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {});
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_genericFocusTrap__WEBPACK_IMPORTED_MODULE_5__/* .GenericFocusTrap */ .G, {
            active: enableFocusTrap,
            focusTrapOptions: {
                clickOutsideDeactivates: !disableModalClose
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .StyledGenericModal */ .Ub, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .StyledGenericModalContainer */ .T2, {
                    maxWidth: maxWidth,
                    height: height,
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-label": ariaLabel || (!header ? name : undefined),
                    "aria-labelledby": ariaLabelledBy || (header ? "modal-header" : undefined),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                header && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .StyledFlexContainer */ .p9, {
                                    header: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .StyledGenericModalHeader */ .m7, {
                                        tabIndex: 0,
                                        id: "modal-header",
                                        children: typeof header === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: header
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: header
                                        })
                                    })
                                }),
                                toggleModal && !disableModalClose && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_X__WEBPACK_IMPORTED_MODULE_4__/* .ConnectedXButton */ .e9, {
                                    onClick: function() {
                                        return toggleModal(false);
                                    },
                                    name: name
                                })
                            ]
                        }),
                        children
                    ]
                })
            })
        });
    };
    return GenericModal;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);



/***/ }),

/***/ 61969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H7": function() { return /* binding */ StyledSecondaryButton; },
/* harmony export */   "Ik": function() { return /* binding */ StyledChangeLocation; },
/* harmony export */   "T2": function() { return /* binding */ StyledGenericModalContainer; },
/* harmony export */   "Ub": function() { return /* binding */ StyledGenericModal; },
/* harmony export */   "dK": function() { return /* binding */ StyledAlertCta; },
/* harmony export */   "iC": function() { return /* binding */ StyledGenericModalContent; },
/* harmony export */   "m7": function() { return /* binding */ StyledGenericModalHeader; },
/* harmony export */   "p9": function() { return /* binding */ StyledFlexContainer; },
/* harmony export */   "vy": function() { return /* binding */ StyledGenericModalFooter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89961);
/* harmony import */ var _components_uielements_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64390);
/* harmony import */ var _components_uielements_primaryButton_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25167);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30438);
/* harmony import */ var _redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73393);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: rgba(0, 0, 0, 0.4);\n  left: 0;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: ",
        ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @media (max-width: 767px) {\n    flex: 1;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  position: relative;\n  padding: ",
        "px 0;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  padding: ",
        "px;\n  width: 100%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0 0 ",
        "px;\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: transparent;\n  border: none;\n  color: ",
        ";\n  cursor: pointer;\n  font-family: ",
        ";\n  font-size: 16px;\n  width: 100%;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  a {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





var StyledGenericModal = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6ed2c60f-0"
})(_templateObject(), _constants_styles__WEBPACK_IMPORTED_MODULE_3__/* .ORDER.MIGRATE_CART */ .kl.MIGRATE_CART);
var _background_color, _border_color, _border_radius;
var StyledGenericModalContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6ed2c60f-1"
})(function(param) {
    var theme = param.theme, maxWidth = param.maxWidth, height = param.height;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        background: (_background_color = theme.modals.background_color) !== null && _background_color !== void 0 ? _background_color : "white",
        border: "1px solid ".concat((_border_color = theme.modals.border_color) !== null && _border_color !== void 0 ? _border_color : "transparent"),
        borderRadius: "".concat((_border_radius = theme.modals.border_radius) !== null && _border_radius !== void 0 ? _border_radius : 0, "px"),
        boxShadow: "inset 0 -1px 0 0 #cccccc",
        overflowY: "scroll",
        maxHeight: "calc(100vh - 100px)",
        width: "450px",
        maxWidth: "".concat(maxWidth !== null && maxWidth !== void 0 ? maxWidth : 500, "px"),
        position: "relative"
    }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_7__/* .getFontStyles */ .l)(theme.modals.font, [
        "color"
    ])), {
        "@media (max-width: 767px)": {
            maxHeight: "".concat(height ? "".concat(height, "px") : "100%"),
            paddingBottom: "20px",
            width: "100%"
        }
    });
});
var StyledGenericModalHeader = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6ed2c60f-2"
})(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        padding: "30px",
        position: "relative",
        margin: "0 auto"
    }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_7__/* .getFontStyles */ .l)(theme.modals.secondary_font)), {
        "h1, h2, h3, h4, p": {
            margin: 0,
            padding: 0
        }
    });
});
var StyledGenericModalContent = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6ed2c60f-3"
})(_templateObject1());
var _border_color1;
var StyledFlexContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6ed2c60f-4"
})(_templateObject2(), _constants_styles__WEBPACK_IMPORTED_MODULE_3__/* .LAYOUT.GUTTER */ ._.GUTTER / 2, function(param) {
    var header = param.header, theme = param.theme;
    return header && "\n    border-bottom: solid 0.5px ".concat((_border_color1 = theme.modals.border_color) !== null && _border_color1 !== void 0 ? _border_color1 : "transparent", ";\n    padding: 0;\n  ");
});
var _footer_color;
var StyledGenericModalFooter = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6ed2c60f-5"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return (_footer_color = theme.modals.footer_color) !== null && _footer_color !== void 0 ? _footer_color : theme.modals.background_color;
}, _constants_styles__WEBPACK_IMPORTED_MODULE_3__/* .LAYOUT.GUTTER */ ._.GUTTER);
var StyledAlertCta = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_components_uielements_primaryButton_styles__WEBPACK_IMPORTED_MODULE_2__/* .StyledPrimaryButton */ .D).withConfig({
    componentId: "sc-6ed2c60f-6"
})(_templateObject4(), _constants_styles__WEBPACK_IMPORTED_MODULE_3__/* .LAYOUT.GUTTER */ ._.GUTTER);
var StyledSecondaryButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.attrs */ .ZP.button.attrs({
    "data-css-override": "StyledSecondaryButton"
}).withConfig({
    componentId: "sc-6ed2c60f-7"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.modals.active_font_color;
}, function(param) {
    var theme = param.theme;
    return theme.primary_font.medium.font_family;
}, _components_uielements_css__WEBPACK_IMPORTED_MODULE_1__/* .LinkHoverCss */ .x);
var StyledChangeLocation = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6ed2c60f-8"
})(_templateObject6());


/***/ }),

/***/ 25167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ StyledPrimaryButton; }
/* harmony export */ });
/* unused harmony export PrimaryButton */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89961);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30694);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30438);
/* harmony import */ var _redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73393);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @keyframes barberpole {\n    from {\n      background-position: 0 0;\n    }\n\n    to {\n      background-position: 101px 0;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var PrimaryButton = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-ebc19a3f-0"
})({
    // Default button styles
    alignItems: "center",
    display: "flex",
    fontWeight: "normal",
    justifyContent: "center",
    lineHeight: "normal",
    overflow: "hidden",
    position: "relative",
    textAlign: "center",
    textDecoration: "none",
    transition: "all 150ms linear"
}, function(param) {
    var theme = param.theme, isLoading = param.isLoading, minWidth = param.minWidth, size = param.size, buttonTheme = param.buttonTheme, disabled = param.disabled, submitting = param.submitting;
    var fontSize = (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFontStyles */ .l)(theme.forms.font, [
        "font_size"
    ]).fontSize;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        cursor: isLoading ? "default" : "pointer",
        fontSize: size === "small" ? "14px" : fontSize,
        height: (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .getHeight */ .Cr)(size, theme.forms.field_height),
        minWidth: minWidth ? "".concat(minWidth, "px") : "100px",
        opacity: isLoading ? 0.3 : 1,
        padding: "0 ".concat(_constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .LAYOUT.GUTTER */ ._.GUTTER, "px"),
        pointerEvents: disabled || submitting ? "none" : "auto"
    }, (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .getButtonThemeProperties */ .jo)(buttonTheme, theme, disabled), (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .getSubmittingProperties */ .mf)(submitting, theme));
});
/*
 * `StyledPrimaryButton` is the actual styled component we use in other components
 * and is necessary so we can attach attributes. We also have the added benefit of defining more
 * obtuse css, like keyframes that are called in the `PrimaryButton` object above
 */ var StyledPrimaryButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(PrimaryButton).attrs({
    "data-css-override": "StyledPrimaryButton"
}).withConfig({
    componentId: "sc-ebc19a3f-1"
})(_templateObject());


/***/ }),

/***/ 30694:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cr": function() { return /* binding */ getHeight; },
/* harmony export */   "X2": function() { return /* binding */ getSafeHoverColor; },
/* harmony export */   "jo": function() { return /* binding */ getButtonThemeProperties; },
/* harmony export */   "mf": function() { return /* binding */ getSubmittingProperties; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96670);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8782);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30438);
/* harmony import */ var _redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73393);
/* harmony import */ var _utils_safePolished__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68902);






function getSafeHoverColor(value, calculatedFrom) {
    if (!value) {
        return "color-mix(in oklab, ".concat(calculatedFrom, ", black 10%)");
    }
    return value;
}
function getHeight(size, defaultHeight) {
    switch(size){
        case "small":
            return "40px";
        case "medium":
            return "50px";
        case "large":
            return "57px";
        default:
            return "".concat(defaultHeight, "px");
    }
}
function getButtonThemeProperties(buttonTheme, theme) {
    var disabled = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var properties = {};
    var _buttons = theme.buttons, knockout_button_background_color = _buttons.knockout_button_background_color, knockout_button_background_hover_color = _buttons.knockout_button_background_hover_color, knockout_button_border_color = _buttons.knockout_button_border_color, knockout_button_border_hover_color = _buttons.knockout_button_border_hover_color, knockout_button_border_radius = _buttons.knockout_button_border_radius, knockout_button_text_hover_color = _buttons.knockout_button_text_hover_color, primary_button_background_color = _buttons.primary_button_background_color, primary_button_background_hover_color = _buttons.primary_button_background_hover_color, primary_button_border_color = _buttons.primary_button_border_color, primary_button_border_hover_color = _buttons.primary_button_border_hover_color, primary_button_border_radius = _buttons.primary_button_border_radius, primary_button_text_hover_color = _buttons.primary_button_text_hover_color, secondary_button_background_color = _buttons.secondary_button_background_color, secondary_button_background_hover_color = _buttons.secondary_button_background_hover_color, secondary_button_border_color = _buttons.secondary_button_border_color, secondary_button_border_hover_color = _buttons.secondary_button_border_hover_color, secondary_button_border_radius = _buttons.secondary_button_border_radius, secondary_button_text_hover_color = _buttons.secondary_button_text_hover_color;
    if (buttonTheme === "secondary") {
        properties = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            background: secondary_button_background_color,
            borderRadius: "".concat(secondary_button_border_radius, "px"),
            border: "1px solid ".concat(secondary_button_border_color)
        }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_3__/* .getFontStyles */ .l)(theme.buttons.secondary_font, [
            "font_family",
            "font_style",
            "font_weight",
            "color",
            "line_height"
        ], {
            color: function(value) {
                if (value === "revert" || value === null) {
                    return (0,_utils_safePolished__WEBPACK_IMPORTED_MODULE_4__/* .safePolished */ .F)(polished__WEBPACK_IMPORTED_MODULE_5__/* .readableColor */ .XV)(theme.buttons.secondary_button_background_color);
                }
                return value;
            }
        })), {
            "&:hover": {
                background: getSafeHoverColor(secondary_button_background_hover_color, secondary_button_background_color),
                borderColor: getSafeHoverColor(secondary_button_border_hover_color, secondary_button_border_color),
                color: secondary_button_text_hover_color !== null && secondary_button_text_hover_color !== void 0 ? secondary_button_text_hover_color : (0,_utils_safePolished__WEBPACK_IMPORTED_MODULE_4__/* .safePolished */ .F)(polished__WEBPACK_IMPORTED_MODULE_5__/* .readableColor */ .XV)(secondary_button_background_color)
            }
        });
    } else if (buttonTheme === "knockout") {
        properties = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            background: knockout_button_background_color,
            borderRadius: "".concat(knockout_button_border_radius, "px"),
            border: "1px solid ".concat(knockout_button_border_color)
        }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_3__/* .getFontStyles */ .l)(theme.buttons.knockout_font, [
            "font_family",
            "font_style",
            "font_weight",
            "color",
            "line_height"
        ], {
            color: function(value) {
                if (value === "revert" || value === null) {
                    return knockout_button_border_color;
                }
                return value;
            }
        })), {
            "&:hover": (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                background: knockout_button_background_hover_color,
                borderColor: getSafeHoverColor(knockout_button_border_hover_color, knockout_button_border_color)
            }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_3__/* .getFontStyles */ .l)(theme.buttons.knockout_font, [
                "color"
            ], {
                color: function(value) {
                    return knockout_button_text_hover_color !== null && knockout_button_text_hover_color !== void 0 ? knockout_button_text_hover_color : value;
                }
            }))
        });
    } else {
        properties = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            background: primary_button_background_color,
            borderRadius: "".concat(primary_button_border_radius, "px"),
            border: "1px solid ".concat(primary_button_border_color)
        }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_3__/* .getFontStyles */ .l)(theme.buttons.primary_font, [
            "font_family",
            "font_style",
            "font_weight",
            "color",
            "line_height"
        ], {
            color: function(value) {
                if (value === "revert" || value === null) {
                    return (0,_utils_safePolished__WEBPACK_IMPORTED_MODULE_4__/* .safePolished */ .F)(polished__WEBPACK_IMPORTED_MODULE_5__/* .readableColor */ .XV)(theme.buttons.primary_button_background_color);
                }
                return value;
            }
        })), {
            "&:hover": {
                background: getSafeHoverColor(primary_button_background_hover_color, primary_button_background_color),
                borderColor: getSafeHoverColor(primary_button_border_hover_color, primary_button_border_color),
                color: primary_button_text_hover_color !== null && primary_button_text_hover_color !== void 0 ? primary_button_text_hover_color : (0,_utils_safePolished__WEBPACK_IMPORTED_MODULE_4__/* .safePolished */ .F)(polished__WEBPACK_IMPORTED_MODULE_5__/* .readableColor */ .XV)(primary_button_background_color)
            }
        });
    }
    if (disabled) {
        properties = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, properties), {
            background: _constants_styles__WEBPACK_IMPORTED_MODULE_0__/* .COLORS.DARKGRAY */ .DM.DARKGRAY,
            border: "none"
        });
    }
    return properties;
}
function getSubmittingProperties() {
    var submitting = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, theme = arguments.length > 1 ? arguments[1] : void 0;
    if (!submitting) {
        return {};
    }
    return {
        ":after": {
            animationName: "barberpole",
            animationDuration: "2s",
            animationTimingFunction: "linear",
            animationIterationCount: "infinite",
            background: "repeating-linear-gradient(\n          -55deg,\n          ".concat(theme.global.primary_active_color, " 1px,\n          ").concat(_constants_styles__WEBPACK_IMPORTED_MODULE_0__/* .COLORS.PRIMARY_NAVY_XX_LIGHT */ .DM.PRIMARY_NAVY_XX_LIGHT, " 2px,\n          ").concat(_constants_styles__WEBPACK_IMPORTED_MODULE_0__/* .COLORS.PRIMARY_NAVY_XX_LIGHT */ .DM.PRIMARY_NAVY_XX_LIGHT, " 11px,\n          ").concat(theme.global.primary_active_color, " 12px,\n          ").concat(theme.global.primary_active_color, " 22px\n        )"),
            bottom: 0,
            content: '""',
            height: "100%",
            left: 0,
            opacity: 0.3,
            position: "absolute",
            right: 0,
            top: 0,
            transition: "opacity 0.3s ease",
            width: "1025px"
        }
    };
}


/***/ }),

/***/ 30438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ COLORS; },
/* harmony export */   "_": function() { return /* binding */ LAYOUT; },
/* harmony export */   "jl": function() { return /* binding */ SPACING_SCALE; },
/* harmony export */   "kl": function() { return /* binding */ ORDER; }
/* harmony export */ });
/* unused harmony export GRID_SIZE */
/*
 * Colors
 */ var WHITE = "#FFF";
var BLACK = "#000";
var DARKBLUE = "#303E47";
var GRAY = "#C5C7C8";
var LIGHTGRAY = "#EDEDED";
var PRIMARY_NAVY = "#313d48";
var PRIMARY_NAVY_LIGHT = "#989ea3";
var PRIMARY_NAVY_X_LIGHT = "#cbced1";
var PRIMARY_GREEN_LIGHT = "#bfe1a3";
var PRIMARY_GREEN_X_LIGHT = "#dff0d1";
var PRIMARY_NAVY_XX_LIGHT = "#f4f5f6";
var PRIMARY_ORANGE = "#f68000";
var PRIMARY_ORANGE_LIGHT = "#f9bc95";
var PRIMARY_ORANGE_X_LIGHT = "#fcddca";
var ERROR_RED = "#ff2d44";
var ERROR_RED_LIGHT = "#ff96a1";
var ERROR_RED_DARK = "#d0021b";
var ERROR_RED_X_LIGHT = "#ffcad0";
var ERROR_RED_BACKGROUND = "#fae1e0";
var WARNING = "#fb6100";
var DARKGRAY = "#666666";
var DARKERGRAY = "#979ea3";
var MEDIUMGRAY = "#E6E8EA";
var SHADOWGRAY = "#F4F5F6";
var HOVERGRAY = "#ededed";
var LIGHTERGRAY = "#cbcfd1";
var BACKGROUNDGRAY = "#eff3f7";
var COLORS = {
    PRIMARY: DARKBLUE,
    BODY: WHITE,
    CONTENT: WHITE,
    HEADER: WHITE,
    TEXT: DARKBLUE,
    SEMI_TRANSPARENT: "rgba(0, 0, 0, 0.4)",
    DARKBLUE: DARKBLUE,
    DARKERGRAY: DARKERGRAY,
    HOVERGRAY: HOVERGRAY,
    GRAY: GRAY,
    LIGHTGRAY: LIGHTGRAY,
    WHITE: WHITE,
    BLACK: BLACK,
    PRIMARY_NAVY: PRIMARY_NAVY,
    PRIMARY_NAVY_LIGHT: PRIMARY_NAVY_LIGHT,
    PRIMARY_NAVY_X_LIGHT: PRIMARY_NAVY_X_LIGHT,
    PRIMARY_NAVY_XX_LIGHT: PRIMARY_NAVY_XX_LIGHT,
    PRIMARY_GREEN_LIGHT: PRIMARY_GREEN_LIGHT,
    PRIMARY_GREEN_X_LIGHT: PRIMARY_GREEN_X_LIGHT,
    PRIMARY_ORANGE: PRIMARY_ORANGE,
    PRIMARY_ORANGE_LIGHT: PRIMARY_ORANGE_LIGHT,
    PRIMARY_ORANGE_X_LIGHT: PRIMARY_ORANGE_X_LIGHT,
    ERROR_RED: ERROR_RED,
    ERROR_RED_LIGHT: ERROR_RED_LIGHT,
    ERROR_RED_DARK: ERROR_RED_DARK,
    ERROR_RED_X_LIGHT: ERROR_RED_X_LIGHT,
    ERROR_RED_BACKGROUND: ERROR_RED_BACKGROUND,
    MEDIUMGRAY: MEDIUMGRAY,
    DARKGRAY: DARKGRAY,
    BACKGROUNDGRAY: BACKGROUNDGRAY,
    SHADOWGRAY: SHADOWGRAY,
    LIGHTERGRAY: LIGHTERGRAY,
    WARNING: WARNING
};
var LAYOUT = {
    ACCOUNT_SIDEBAR_WIDTH: 250,
    MOBILE_BREAKPOINT: 768,
    HEADERHEIGHT: 80,
    STICKY_MENUHEIGHT_DESKTOP: 100,
    STICKY_MENUHEIGHT_MOBILE: 70,
    ITEM_HEADERHEIGHT: 68,
    MOBILE_HEADERHEIGHT: 50,
    MOBILE_ITEM_HEADERHEIGHT: 60,
    MOBILE_STORE_MENUHEIGHT: 65,
    LOYALTY_MENU_HEIGHT_DESKTOP: 80,
    LOYALTY_MENU_HEIGHT_MOBILE: 60,
    TOASTHEIGHT: 50,
    MAXWIDTH: 1440,
    GUTTER: 20,
    LINE_HEIGHT: 1.5,
    H_SPACING: 50,
    MEDIUM_CONTENT: 655,
    CUSTOMIZE_PRODUCT_DETAIL_WIDTH: 350,
    MAX_CHECKOUT_CONTAINER_WIDTH: 655,
    MAX_LOYALTY_CONTAINER_WIDTH: 1200,
    MOBILE_MAP_LOCATION_CARD_HEIGHT: 190,
    MOBILE_LIST_MAP_FOOTER_HEIGHT: 35,
    CUSTOMIZE_MODAL_MAX_WIDTH: 900,
    CUSTOMIZE_FOOTER_MAX_HEIGHT: 140,
    LEFT_CATEGORY_NAV_MIN_WIDTH: 200,
    LEFT_CATEGORY_NAV_MAX_WIDTH: 275,
    PRIMARY_BUTTON_LARGE_HEIGHT: 57,
    QUANTITY_SELECTOR_HEIGHT: 40,
    MENU_SEARCH_HEIGHT: 48,
    MENU_SEARCH_RESULT_HEIGHT: 68,
    NAV_BOTTOM_BORDER_WEIGHT: 1,
    GOOGLE_MAP_HEIGHT: 438,
    MAIN_CONTAINER_WIDTH: 1142
};
var SPACING_SCALE = {
    TWOXS: 4,
    THREEXS: 8,
    XS: 12,
    SMALL: 16,
    MEDIUM: 24,
    LARGE: 32,
    XL: 48,
    TWOXL: 64,
    THREEXL: 72
};
var GRID_SIZE = {
    ONE: "1x",
    TWO: "2x"
};
/*
 * Order
 */ var ORDER = {
    ACCOUNT_DROPDOWN: 22,
    PREVIEWER: 21,
    TOOLTIP: 20,
    TOAST: 19,
    TAKEOVER: 18,
    LOADING: 16,
    CUSTOMIZE: 14,
    MIGRATE_CART: 14,
    OVERLAY: 13,
    CART: 13,
    BARBER_LOADING: 12,
    SKIP_TO_CONTENT: 12,
    STORE_DETAIL: 11,
    HEADER: 11,
    LOYALTY_HEADER: 9,
    MENU: 9,
    MAP: 8,
    STORE_CARD_MENU: 8,
    MENU_SEARCH_RESULTS: 10,
    MENU_SEARCH_MODAL: 10,
    LOADING_SKELETON: 2
};


/***/ }),

/***/ 73393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ getFontStyles; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96670);



/** @TODO rename this function since it does more post-processing. */ function snakeToPascal(fontProperty) {
    var transformed = {};
    if (fontProperty.color) {
        transformed.color = fontProperty.color;
    }
    if (fontProperty.font_size) {
        transformed.fontSize = typeof fontProperty.font_size === "number" ? "".concat(fontProperty.font_size, "px") : fontProperty.font_size;
    }
    if (fontProperty.font_style) {
        transformed.fontStyle = fontProperty.font_style;
    }
    if (fontProperty.font_weight) {
        transformed.fontWeight = fontProperty.font_weight;
    }
    if (fontProperty.font_family) {
        transformed.fontFamily = fontProperty.font_family;
    }
    if (fontProperty.line_height) {
        transformed.lineHeight = typeof fontProperty.line_height === "number" ? "".concat(fontProperty.line_height, "px") : fontProperty.line_height;
    }
    return transformed;
}
function getOverrides(fontProp, overrides) {
    var transformed = fontProp;
    if (!overrides) {
        return transformed;
    }
    // in order to iterate over an object in a type safe way, we're using `for..in`
    for(var key in overrides){
        var fn = overrides[key];
        var value = fontProp[key];
        transformed = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, transformed), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, key, typeof fn === "function" ? fn(value) : value));
    }
    return transformed;
}
function getFontStyles(fontProp, includeOrOverride, overrides) {
    // normalize include and override values due to overload variations
    var scopedInclude = Array.isArray(includeOrOverride) ? includeOrOverride : undefined;
    var scopedOverride = Array.isArray(includeOrOverride) ? overrides : includeOrOverride;
    // check all properties for overrides first
    var transformed = getOverrides(fontProp, scopedOverride);
    // finally, filter down the property list, if requested
    if (scopedInclude) {
        transformed = scopedInclude.reduce(function(acc, key) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, key, transformed[key]));
        }, {});
    }
    return snakeToPascal(transformed);
}


/***/ }),

/***/ 70595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Wr": function() { return /* binding */ getProductImageSrc; },
/* harmony export */   "dU": function() { return /* binding */ hasProductImage; },
/* harmony export */   "nq": function() { return /* binding */ IMAGE_RESIZER; },
/* harmony export */   "tg": function() { return /* binding */ resizeImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66383);

var IMAGE_RESIZER = "https://media.koala.io/resize";
/**
 * Get the correct image source for a product.
 *
 * If image property exists and equal to image_url_1_by_1 that it means that image property is set by provider
 * and we should default to it without resizing.
 *
 * If image property is not equal to image_url_1_by_1 that it means that image property does not exist
 * OR image_url_1_by_1 is set in CMS
 * and should be set as default and resized.
 *
 * @param product Menu or Basket product object
 * @param resizeOptions  Options to pass to the image resizer
 */ var getProductImageSrc = function(product, resizeOptions) {
    var image = product.image, images = product.images;
    if (image && (images === null || images === void 0 ? void 0 : images.image_url_1_by_1) === image) {
        return image;
    } else {
        return resizeImage(images === null || images === void 0 ? void 0 : images.image_url_1_by_1, resizeOptions);
    }
};
var hasProductImage = function(product) {
    var image = product.image, images = product.images;
    return Boolean(image || (images === null || images === void 0 ? void 0 : images.image_url_1_by_1));
};
/** Take a url and feed it to the image resizer.  */ function resizeImage(url) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, height = ref.height, width = ref.width, _quality = ref.quality, quality = _quality === void 0 ? 85 : _quality, _format = ref.format, format = _format === void 0 ? "auto" : _format;
    // Ensure url exists
    if (!url) {
        return "";
    }
    // Don't try to resize vector graphics like SVGs & PDFs
    if (url.endsWith(".svg") || url.endsWith(".pdf")) {
        return url;
    }
    var params = Object.entries({
        height: height,
        width: width,
        quality: quality,
        format: format
    }).filter(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(param, 2), _k = _param[0], v = _param[1];
        return !!v;
    }).map(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(param, 2), k = _param[0], v = _param[1];
        return "".concat(k, "=").concat(v);
    }).join("&");
    return "".concat(IMAGE_RESIZER, "?source=").concat(url, "&").concat(params);
}


/***/ }),

/***/ 68902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ safePolished; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50930);
/* harmony import */ var _utils_errorReporter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19663);


/**
 * A safe wrapper around polished functions that will catch any errors thrown by polished
 * and return a set fallback
 *
 * Default fallback is any empty string because StyledComponents (and CSS) will safely ignore that
 *
 * @param fn polished function
 * @param fallback optional fallback
 * @returns safe wrapper around polished function
 */ var safePolished = function(fn) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        try {
            return fn.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(args));
        } catch (error) {
            _utils_errorReporter__WEBPACK_IMPORTED_MODULE_1__/* .captureException */ .Tb(error, "error");
            return fallback;
        }
    };
};


/***/ })

}]);